// Sensitive data patterns to filter out
export const SENSITIVE_PATTERNS = [
  /password/i,
  /token/i,
  /api[_-]?key/i,
  /secret/i,
  /authorization/i,
  /bearer/i,
  /credit[_-]?card/i,
  /ssn/i,
  /social[_-]?security/i,
]

// Route-based sampling configuration
export const ROUTE_SAMPLING_RATES: Record<string, number> = {
  '/dashboard': 0.1, // 10% sampling for dashboard
  '/active-studies': 0.5, // 50% sampling for active studies
  '/results': 0.3, // 30% sampling for results
  '/new-study': 1.0, // 100% sampling for new studies (critical path)
  '/settings': 0.05, // 5% sampling for settings
} 